module.exports = __webpack_public_path__ + "img/collection-weddingRingsTwoColors.ccc0d06.jpg";